import { StyleSheet } from 'aphrodite'
import merge from 'deepmerge'
import { default as colors } from './colors'
import { default as fontSizes } from './fontSizes'
import { default as fontWeights } from './fontWeights'
import { default as fontStyles } from './fontStyles'

export { colors, fontSizes, fontWeights, fontStyles }

const defaultTheme = {
  colors,
  fontSizes,
  fontWeights,
  fontStyles,
}

export default function createStyles(styleCreator) {
  return (props, context) => {
    const theme = merge.all([
      defaultTheme,
      props.theme || {},
      context.theme || {},
    ])
    const styles = styleCreator(props, context, theme)

    return StyleSheet.create(styles)
  }
}



// WEBPACK FOOTER //
// ./src/components/styles/index.js